import { EnderecoDTO } from "./EnderecoDTO";

export class LocalizacaoDTO {
  endereco: EnderecoDTO;
  latitude?: number;
  longitude?: number;
  nomeResponsavel?: string;
  telefoneResponsavel?: string;

  constructor(endereco: EnderecoDTO, latitude?: number, longitude?: number, nomeResponsavel?: string, telefoneResponsavel?: string) {
    this.endereco = endereco;
    this.latitude = latitude;
    this.longitude = longitude;
    this.nomeResponsavel = nomeResponsavel;
    this.telefoneResponsavel = telefoneResponsavel;
  }
}
